export const gaPush = (data) => {
  // extend given data by dealer name and dealer id
  // use data from global trackingData object that contains
  // dealer data that is rendered in backend
  if (!data.category) {
    if (!data.dealerName && window.trackingData?.dealer?.name) {
      data.dealerName = window.trackingData.dealer.name;
    }

    if (!data.dealerNumber && window.trackingData?.dealer?.id) {
      data.dealerNumber = window.dealer.id;
    }
  }

  window.dataLayer && window.dataLayer.push(data);
};
